<template>
  <el-dialog
    v-if="elderDialogVisible"
    :title="name"
    custom-class="vpop-dialog w1200"
    top="10vh"
    :visible.sync="elderDialogVisible"
    append-to-body
    @close="hidePop"
  >
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="dialog-cell">
          长者姓名：{{ alarmData.agedName || "--" }}
        </div>
      </el-col>
      <el-col :span="12">
        <div class="dialog-cell">
          长者身份证号码：{{ alarmData.agedIdCard || "--" }}
        </div></el-col
      >
      <el-col :span="12">
        <div class="dialog-cell">
          长者年龄：{{ alarmData.age || "--" }}
        </div></el-col
      >
      <el-col :span="12">
        <div class="dialog-cell">
          长者性别：{{ alarmData.agedGender | getGender }}
        </div>
      </el-col>
      <el-col :span="12">
        <div class="dialog-cell">
          长者联系方式：{{ alarmData.agedPhone || "--" }}
        </div>
      </el-col>
      <el-col :span="24">
        <div class="dialog-cell">
          长者居住地址：{{ alarmData.agedLiveDetailLocation || "--" }}
        </div>
      </el-col>
      <el-col :span="12">
        <div class="dialog-cell">
          报警类型：{{ alarmData.warningTypeName || "--" }}
        </div>
      </el-col>
      <el-col :span="12">
        <div class="dialog-cell">
          报警时间：{{ alarmData.accidentOccurDatetime || "--" }}
        </div>
      </el-col>
      <el-col :span="12">
        <div class="dialog-cell">
          报警内容：{{ alarmData.accidentResume || "--" }}
        </div>
      </el-col>
      <el-col :span="24">
        <div class="dialog-cell">
          已安装设备：
          <template v-for="(item,key) in alarmData.deviceList">
            <el-tooltip class="item" v-if="item.status == '在线'" :key="key" effect="dark" content="在线" placement="top">
            <span class="ml10 equment off" >{{item.name}}</span></el-tooltip>
            <el-tooltip class="item" v-else :key="key" effect="dark" content="离线" placement="top">
              <span class="ml10 equment" >{{item.name}}</span>
            </el-tooltip>
          </template>
          
          <img src="" alt="">
        </div>
      </el-col>
      <el-col :span="12">
        <div class="dialog-cell">
          能力等级：{{alarmData.disabilityLevel}}
          <img src="" alt="">
        </div>
      </el-col>
      <el-col :span="12" v-if="alarmData.videoPath && alarmData.videoPath != ''">
        <div class="dialog-cell">查看监控：
          <img @click="toVideo(alarmData)" class="video" src="../assets/images/jc/video.png" alt="">
        </div>
      </el-col>
      <el-col :span="24" v-if="alarmData.beforePhotos && alarmData.beforePhotos.length > 0">
        <div class="dialog-cell">安装前照片：
          <el-image v-for="(item,key) in alarmData.beforePhotos" v-if="item != ''" :key="key" class="el-images" :src="item" :preview-src-list="alarmData.beforePhotos"></el-image>
        </div>
      </el-col>
      <el-col :span="24" v-if="alarmData.afterPhotos && alarmData.afterPhotos.length > 0">
        <div class="dialog-cell">安装后照片：
          <el-image v-for="(item,key) in alarmData.afterPhotos" v-if="item != ''" :key="key" class="el-images" :src="item" :preview-src-list="alarmData.afterPhotos"></el-image>
        </div>
      </el-col>
    </el-row>
    <JCvideo></JCvideo>
  </el-dialog>
</template>

<script>
import PubSub from "pubsub-js";
import JCvideo from "./JCvideo";
export default {
  name: "JCMapDialog",
  data() {
    return {
      elderDialogVisible: false,
      name: "老人信息",
      alarmData: {},
    };
  },
  components:{
    JCvideo
  },
  filters: {
    getGender(data) {
      if (data == 1) {
        return "男";
      } else if (data == 2) {
        return "女";
      } else {
        return "其他";
      }
    },
  },
  watch: {},
  mounted() {
    let that = this;
    PubSub.subscribe("JCMapPoint", (msg, data) => {
      that.elderDialogVisible = true;
      that.alarmData = data;
      that.alarmData.beforePhotos = data.beforePhotos.split(";")
      that.alarmData.afterPhotos = data.afterPhotos.split(";")
      console.log(data.videoPath)
    });
  },
  methods: {
    hidePop() {},
    toVideo(data) {
      console.log(data)
      let id = data.id;
      let link = data.videoPath
      PubSub.publish("JCvideo", {
        visible: true,
        list: link,
        id:id
      });
    },
    
  },
};
</script>

<style lang="scss" scoped> 
.el-images{
  width: 100px; height: 100px;
  margin-left: 10px;
  margin-bottom: 20px;
}
.video{
  width: 30px;
  height: 30px;
}
.off{
  color: #43ff14!important;
}
.equment{
  font-weight: bold;
  color: #ff1414;
  font-size: 18px;
}
.ml10{
  margin-left: 10px;
}
.dialog-cell {
  line-height: 3vh;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}
.pagination {
  margin-top: 10px;
}

.select {
  margin-bottom: 10px;
}

.pop-equment {
  width: 30px;
  height: 30px;
}

.video {
  cursor: pointer;
}
</style>